// extracted by extract-css-chunks-webpack-plugin
module.exports = {"stock_search":"stock_search-2erTkqgI clearfix","text":"text-1NsXLbbd","btn":"btn-2xSmwRij"};